import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M7 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 20q0-.825.588-1.412A1.93 1.93 0 0 1 7 18q.825 0 1.413.588T9 20q0 .825-.587 1.413A1.92 1.92 0 0 1 7 22m10 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 15 20q0-.825.588-1.412A1.93 1.93 0 0 1 17 18q.825 0 1.413.588T19 20q0 .825-.587 1.413A1.92 1.92 0 0 1 17 22M6.15 6l2.4 5h7l2.75-5zM5.2 4h14.75q.575 0 .875.513t.025 1.037l-3.55 6.4a2 2 0 0 1-.737.775A1.95 1.95 0 0 1 15.55 13H8.1L7 15h11q.425 0 .713.288T19 16a.97.97 0 0 1-.288.713A.96.96 0 0 1 18 17H7q-1.125 0-1.7-.987t-.05-1.963L6.6 11.6 3 4H2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 3q0-.424.288-.712A.97.97 0 0 1 2 2h1.625q.274 0 .525.15.25.15.375.425z"
    }, null, -1)
  ]))]))
}
export default { render: render }